import { render, staticRenderFns } from "./banners-components.vue?vue&type=template&id=db6f43ec&scoped=true"
import script from "./banners-components.vue?vue&type=script&lang=js"
export * from "./banners-components.vue?vue&type=script&lang=js"
import style0 from "./banners-components.vue?vue&type=style&index=0&id=db6f43ec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6f43ec",
  null
  
)

export default component.exports